import { ButtonSize, ButtonType, JokerButton } from "material-ui-jokerpro";
import AssetsPack from "../../util/AssetsPack";
import AutoPlayMutedVideo from "../AutoPlayMutedVideo";
import Paragraph, { ParagraphSize } from "../Paragraph";
import TitleText, { TitleTextSize } from "../TitleText";
import styles from "./DownloadFooter.module.css";
import React from "react";
import ImageComponent from "../ImageComponent";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { ApkLink } from "../../util/Constant";

interface DownloadOptionsProps {
  title: string;
  icon: string;
  buttonName: string;
  redirect: string;
  isDisable?: boolean;
  goldText?: boolean;
}

const DownloadFooter = () => {
  const { t } = useTranslation();

  const DownloadOptions: React.FC<DownloadOptionsProps> = ({
    title,
    icon,
    buttonName,
    redirect,
    isDisable = false,
    goldText = false,
  }) => {
    return (
      <div className={styles["download-options"]}>
        <div className={styles["download-options-text-container"]}>
          <ImageComponent src={icon} />
          <Paragraph
            size={ParagraphSize.paragraph1}
            classNameStyle={clsx(
              styles["download-option-text"],
              goldText && styles["white-text"]
            )}
          >
            {title}
          </Paragraph>
        </div>
        <JokerButton
          text={buttonName}
          type={ButtonType.CTA}
          size={ButtonSize.Medium}
          href={redirect}
          icon={AssetsPack.icons.ICON_GO.default}
          disabled={isDisable}
        />
      </div>
    );
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["video-container"]}>
        <AutoPlayMutedVideo
          videoSrc={AssetsPack.videos.JOKER_PRO_LOGO_VIDEO}
          classNameStyle={styles["logo-video"]}
        />
      </div>
      <div className={styles["info-container"]}>
        <TitleText size={TitleTextSize.heading3}>Download Joker Plus</TitleText>
        <Paragraph
          size={ParagraphSize.paragraph2}
          classNameStyle={styles["description"]}
        >
          {t("joker_download_page.download_footer.current_available")}
          <strong className={styles["text-highlight"]}>
            {t("joker_download_page.download_footer.android_only")}
          </strong>
        </Paragraph>

        <div className={styles["download-container"]}>
          <JokerButton
            text={t("global_component.download_apk")}
            type={ButtonType.CTA}
            size={ButtonSize.Medium}
            href={"/download"}
            icon={AssetsPack.icons.ICON_GO.default}
          />
        </div>
        <div className={styles["note-view"]}>
          <ImageComponent src={AssetsPack.icons.ICON_TICK.default} />
          <div className={styles["note-text"]}>
            {t("joker_download_page.download_footer.step-by-step")}
          </div>
        </div>
      </div>

      <div className={styles["bottom-container"]}>
        <div className={styles["download-note"]}>
          <Paragraph size={ParagraphSize.paragraph2}>
            {t("joker_download_page.download_footer.joker_plus_is")}
            <strong className={styles["text-highlight"]}>
              {t("joker_download_page.download_footer.available_android")}
            </strong>
            {t("joker_download_page.download_footer.available_android_note")}
          </Paragraph>
        </div>
        <div className={styles["button-container"]}>
          <DownloadOptions
            title={t("global_component.android")}
            buttonName={t("global_component.installation_guide")}
            icon={AssetsPack.icons.ICON_ANDROID.default}
            redirect={ApkLink}
            goldText
          />
          <DownloadOptions
            title={t("global_component.ios")}
            buttonName={t("global_component.coming_soon")}
            icon={AssetsPack.icons.ICON_IOS.default}
            redirect={"/download"}
            isDisable
          />

          <DownloadOptions
            title={t("global_component.web")}
            buttonName={t("global_component.coming_soon")}
            icon={AssetsPack.icons.ICON_WEB.default}
            redirect={"/download"}
            isDisable
          />
        </div>
      </div>
    </div>
  );
};

export default DownloadFooter;
